import { toJS } from 'mobx';
import { applySnapshot, getRoot, types } from 'mobx-state-tree';
import ObjectPath from 'object-path';
import { IGlobalStore } from '@store/index';

const Common = types
  .model({})
  .views((self) => ({
    get globalStore(): IGlobalStore {
      return getRoot<IGlobalStore>(self);
    },
  }))
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate: () => {
        initialState = toJS(self);
      },
      reset() {
        applySnapshot(self, initialState);
      },
      replace(data: typeof self) {
        applySnapshot(self, data);
      },
      /* eslint-disable @typescript-eslint/no-explicit-any*/
      updateField: (field: string, value: any) => {
        ObjectPath.set(self, field, value);
        applySnapshot(self, self);
      },
    };
  });

export default Common;
